import { useState } from "react";
import { Nav, NavItem, NavLink, TabContent, TabPane } from "reactstrap";

const TabComponent = ({children}) => {
  const [activeTab, setActiveTab] = useState("1");

  const handleChangeTab = (tab) => {
    setActiveTab(tab)
  }

  return(
    <div>
      <Nav className="my-5" tabs justified>
        {
          ["1", "2", "3", "4"].map((tw) => (
            <NavItem key={tw}>
              <NavLink
                className={activeTab === tw ? "active" : ""}
                onClick={() => handleChangeTab(tw)}
              >
                {`Triwulan ${tw}`}
              </NavLink>
            </NavItem>
          ))
        }
      </Nav>
      <TabContent activeTab={activeTab}>
        {["1", "2", "3", "4"].map((tw, i) => (
            <TabPane tabId={tw} key={i}>
              {children(tw)}
            </TabPane>
          )
        )}
      </TabContent>
    </div>
  )
}

export default TabComponent;